import { useOrderInfo } from 'contexts/OrderInfoContext'
import { useNavigate } from 'react-router-dom'
import { displayPrice } from 'utils/strings'
import Modal from 'components/Modal/Modal'
import React, { useState } from 'react'
import Loader from 'components/Loader'
import { POST } from 'api/request'
import * as urls from 'api/urls'

interface OrderInfoModalProps {
  onClose: (refresh?: boolean) => void
}

const OrderInfoModal: React.FC<OrderInfoModalProps> = ({ onClose }) => {
  const [orderInfo, data] = useOrderInfo()
  const [isSending, setSending] = useState(false)
  const itIsPossibleToAdd = data && !data?.is_attached
  const isPaid = data && data?.is_paid

  const navigate = useNavigate()
  const attachOrder = async () => {
    if (isSending) return
    setSending(true)
    try {
      const response = await POST(urls.attachOrders, { body: { orders: [orderInfo] } })
      if (response.ok) {
        onClose(true)
      } else {
        setSending(false)
      }
    } catch (error) {
      setSending(false)
    }
  }

  return (
    <Modal
      icon='tabliczka'
      title='Zakupione tabliczki'
      onClose={onClose}
      primaryButton={isPaid ? itIsPossibleToAdd ? isSending ? 'wysyłanie...' : 'Dodaj do konta' : 'Zamknij' : 'Ponów transakcję'}
      primaryButtonAction={isPaid ? itIsPossibleToAdd ? attachOrder : onClose : () => { navigate('/order') }}
      secondaryButton={itIsPossibleToAdd || !isPaid ? 'Pomiń' : undefined}
      secondaryButtonAction={itIsPossibleToAdd || !isPaid ? 'close' : undefined}>
      {data
        ? <div className='orderInfo__modal'>
          {!itIsPossibleToAdd &&
            <div className='infobox'>
              Tabliczki zostały już przypisane
            </div>}

          {!isPaid && <div className='infobox'>
            Tabliczki nie zostały opłacone!
          </div>}

          {isPaid && data.positions.map(({ id, name, gross_price, addons, amount }) => (
            <div className={`item ${addons && addons.length > 0 && 'item--addons'}`} key={id}>
              <div className="standard">
                <p>{amount > 1 ? `${amount} x ` : ''}{name}</p>
                <span>{displayPrice(Number(gross_price) * amount)}</span>
              </div>
              {addons && addons.length > 0 && (
                <div className="addons">
                  {addons.map(({ id, name, gross_price, amount }) => (
                    <div className="item addon" key={id}>
                      <p>{amount > 1 ? `${amount} x ` : ''}{name}</p>
                      <span>{displayPrice(Number(gross_price) * amount)}</span>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
        : <Loader type='full' />}
    </Modal>
  )
}

export default OrderInfoModal